export enum SemanticNameEnum {
  LAST_RSVP = 'lastrsvp',
  RSVPS = 'rsvps',
  CONTACT_COST = 'contactcost',
  PUBLIC_OFFICIAL = 'public-official',
  ATTENDANCE = 'attendance',
  COMPANY = 'company',
  JOB_TITLE = 'jobtitle',
}
